import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { collection, getDocs } from 'firebase/firestore';
import { db } from "../firebase";
import { motion } from 'framer-motion';

function Pro({ user, setIsLoggedIn, searchQuery }) {
  const [projects, setProjects] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    // Function to fetch projects data
    const fetchProjects = async () => {
      const projectsCollection = collection(db, 'Projects');
      const projectsSnapshot = await getDocs(projectsCollection);
      const projectsData = projectsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setProjects(projectsData);
    };

    fetchProjects();
  }, []);

  const handleUpdateCode = (project) => {
    if (user) {
      setIsLoggedIn(true);
      navigate(`/updatecode/${project.id}`, { state: { project } });
    } else {
      // If not logged in, redirect to login
      navigate('/home/login');
    }
  };

  const filteredProjects = projects.filter(project =>
    project.title.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="w-full py-6 flex items-center justify-center gap-6 flex-wrap">
      {filteredProjects.map(project => (
        <motion.div key={project.id}
          className='w-full cursor-pointer md:w-[450px] h-[375px] bg-secondary rounded-md p-4 flex flex-col items-center justify-center gap-4'
          onClick={() => handleUpdateCode(project)}>

          <div className="bg-primary w-full h-full rounded-md overflow-hidden">
            <iframe
              title='Result'
              srcDoc={project.output}
              style={{ border: "none", width: "100%", height: "100%" }}
            />
          </div>
          <div className="flex items-center justify-start gap-3 w-full">
            <div className="w-14 h-14 flex items-center justify-center rounded-xl overflow-hidden cursor-pointer bg-emerald-400">
              <p className="text-xl text-white font-semibold capitalize">{project.user.email[0]}</p>
            </div>
            <div>
              <p className="text-white text-lg capitalize">{project.title}</p>
              <p className="text-primaryText text-sm capitalize">{project.user.displayName}</p>
            </div>
          </div>
        </motion.div>
      ))}
    </div>
  );
}

export default Pro;
